import { Button, Divider, Form, Input, Space } from 'antd'
import PropTypes from 'prop-types'
import { useState } from 'react'
import { Icon } from '../../'
import { translations } from '../../../constants'
import { trimFields } from '../../../utils'

const EuForm = ({
  hideModal,
  isFormNeedPaymentMethods = true,
  locale = 'us',
  onSubmit,
  selectedStore,
}) => {
  const [form] = Form.useForm()
  const [isModalLoading, setModalLoading] = useState(false)

  const handleSubmit = () => {
    const isFormUpdated = form.isFieldsTouched()
    if (isFormUpdated) {
      form
        .validateFields()
        .then(() => {
          setModalLoading(true)
          const requiredFieldsValue = {
            ...trimFields(form.getFieldsValue()),
            iban: form.getFieldValue('iban'),
            store_id: selectedStore.id,
          }

          onSubmit({
            country: 'eu',
            requiredFieldsValue,
            setModalLoading,
          })
        })
    }
  }

  return (
    <Form
      data-test="bank-details-form"
      data-testid="euForm"
      form={form}
      layout="vertical"
      onFinish={handleSubmit}
    >
      <Form.Item
        className="bankDetailsIban"
        label={translations[locale].iban}
        name="iban"
        rules={[
          {
            message: translations[locale].addIban,
            required: true,
          },
          {
            message: translations[locale].addValidIban,
            pattern: /^[a-zA-Z0-9 ]{14,34}$/,
          },
        ]}
      >
        <Input onBlur={(current) => form.setFieldValue('iban', current.target.value.replace(/\s+/g, ''))} />
      </Form.Item>

      <Form.Item
        label={translations[locale].legalEntity}
        name="legal_entity"
        rules={[{ message: translations[locale].addLegalEntity, required: true }]}
        tooltip={{ icon: <Icon type="infoCircle" />, title: translations[locale].legalEntityTooltip }}
      >
        <Input />
      </Form.Item>

      <Form.Item
        label={translations[locale].reportingEmail}
        name="reporting_email"
        rules={[
          {
            message: translations[locale].addReportingEmail,
            type: 'email',
          },
          {
            message: translations[locale].addValidReportingEmail,
            required: true,
          },
        ]}
      >
        <Input />
      </Form.Item>

      <Divider />

      <Space
        size="middle"
        style={{
          display: 'flex',
          justifyContent: 'end',
        }}
      >
        {isFormNeedPaymentMethods && <Button className="bankDetailsCancel" name="cancelBtnSelenium" onClick={hideModal}>Cancel</Button>}
        <Button className="bankDetailsSubmit" htmlType="submit" loading={isModalLoading} name="submitBtnSelenium" type="primary">{translations[locale].submit}</Button>
      </Space>
    </Form>
  )
}

EuForm.propTypes = {
  hideModal: PropTypes.func,
  isFormNeedPaymentMethods: PropTypes.bool,
  locale: PropTypes.string,
  onSubmit: PropTypes.func.isRequired,
  selectedStore: PropTypes.object.isRequired,
}

export default EuForm
